// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_user_files_s3_bucket": "ugtdb-tib-prod-s3tibprodugtdb5094d93f-1rmju6fmzr79j", //prod
  "aws_user_files_s3_bucket_region": "us-east-1",
  Auth: {
    identityPoolId: "us-east-1:c3c3528d-b899-4443-a654-b903b100cba1",
    region: "us-east-1",

    oauth: {
    },
  },
  API: {
    endpoints: [
      {
        name: "P450",
        endpoint: "https://5mjkajyud8.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
      {
        name: "SMILES",
        endpoint: "https://tjbet311j2.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
      {
        name: "Substrate",
        endpoint: "https://l1yxpe905m.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
      {
        name: "UGT",
        endpoint: "https://4cc2mhnih1.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
    ],
  }
};


export default awsmobile;
